import { createFileRoute, Link, Outlet } from "@tanstack/react-router";
import { cn } from "@theprelude/core";
import {
  BlockListIcon,
  Dropdown,
  DropdownContent,
  DropdownRadio,
  DropdownRadioGroup,
  DropdownTrigger,
  IconButton,
  LoadingPage,
} from "@theprelude/ds";
import { Suspense } from "react";
import { setPageTitle, useTitleStore } from "@/components/app-shell/app-shell";
import { usePopper } from "@/hooks/use-popper";
import { authorizeFeatures } from "@/lib/authorize-feature";

export const Route = createFileRoute("/_app/threat-intel/import")({
  beforeLoad: async ({ context }) => {
    setPageTitle("Threat Intel");
    await authorizeFeatures(context, ["detect", "threat_intel"]);
  },
  component: ThreatIntelImportLayout,
});

function ThreatIntelImportLayout() {
  const dropdown = usePopper();
  const title = useTitleStore((state) => state.value);

  const isThreatIntelFeedRoute =
    window.location.pathname === "/threat-intel/import/feed" ||
    window.location.pathname === "/threat-intel/import/feed-notice";

  return (
    <section className="flex flex-1 flex-col overflow-hidden bg-primary-background sm:flex-row">
      <aside className="hidden w-[20.125rem] shrink-0 flex-col px-4 py-6 dark:border-r dark:border-stroke-line sm:flex">
        <nav>
          <Link
            to="/threat-intel/import/feed"
            className={cn(
              "flex h-[2.5rem] items-center p-2",
              isThreatIntelFeedRoute && "bg-tertiary-foreground font-medium",
            )}
            activeProps={{
              className: "bg-tertiary-foreground font-medium",
            }}
          >
            CrowdStrike Falcon Feed
          </Link>
          <Link
            to="/threat-intel/import/upload"
            className="flex h-[2.5rem] items-center p-2"
            activeProps={{
              className: "bg-tertiary-foreground font-medium",
            }}
          >
            Upload Threat Intelligence
          </Link>
        </nav>
      </aside>
      <div className="ml-auto flex px-6 pt-6 sm:hidden">
        <Dropdown {...dropdown}>
          <DropdownTrigger asChild>
            <IconButton icon={<BlockListIcon />} />
          </DropdownTrigger>
          <DropdownContent align="end">
            <DropdownRadioGroup value={title}>
              <Link to="/threat-intel/import/feed">
                <DropdownRadio value="Feed">
                  CrowdStrike Falcon Feed
                </DropdownRadio>
              </Link>
              <Link to="/threat-intel/import/upload">
                <DropdownRadio value="Upload">
                  Upload Threat Intelligence
                </DropdownRadio>
              </Link>
            </DropdownRadioGroup>
          </DropdownContent>
        </Dropdown>
      </div>
      <main className="flex w-full flex-1 flex-col bg-surface-background">
        <Suspense fallback={<LoadingPage />}>
          <Outlet />
        </Suspense>
      </main>
    </section>
  );
}
